<template>
	<Error :errors="errors"/>
	<!-- <div class="banner">
		<img alt="Banner" src="/banner-motul-web.jpg"/>
	</div> -->
	<div class="grid">
		<div class="col-12 lg:col-12 xl:col-12">

			<div class="surface-section px-4 py-8 md:px-6 lg:px-8">
				<div class="text-700 text-center">
					<div class="text-blue-600 font-bold mb-3">&nbsp;WELCOME TO</div>
					<div class="text-900 font-bold text-5xl mb-3">Web Report - {{appsName}}</div>
				</div>
			</div>
		</div>
	</div>

	<div class="grid">
		<div class="col-12 md:col-6 lg:col-3">
			<UserAktif/>
        </div>
		<div class="col-12 md:col-6 lg:col-3">
			<EC/>
        </div>
	</div>

	<div class="grid">
		<div class="col-12 md:col-12 lg:col-12">
			<div class="card">
				<h4>Summary</h4>
				<SummaryDataTable/>
			</div>
        </div>
	</div>

</template>

<script>

import { mapGetters } from "vuex";
import Error from '../components/Error.vue';
import UserAktif from '../components/dashboard/UserAktif.vue';
import EC from '../components/dashboard/EC.vue';
import SummaryDataTable from '../components/dashboard/SummaryDataTable.vue';

export default {
	components: {
		'UserAktif': UserAktif,
		'EC': EC,
		'SummaryDataTable': SummaryDataTable,
		'Error': Error,
	},
	data() {
		return {		
			appsName: process.env.VUE_APP_APPS_NAME,
		}
	},
    mounted() {
        this.$store.commit('setErrors', {});
    },
    computed:{
        ...mapGetters(['errors']),
    },
}
</script>
<style>
	.banner {
		width: 100%;
		/* height: 200px; */
		background-color: #f0f0f0;
		display: flex;
		justify-content: center;
		align-items: center;
	}

	.banner img {
		max-width: 100%;
		max-height: 100%;
		object-fit: contain;
	}
</style>